import script from "./ClassicResetLinkSentStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicResetLinkSentStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicResetLinkSentStep.vue?vue&type=style&index=0&id=19c15569&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c15569"]])

export default __exports__